// extracted by mini-css-extract-plugin
export default {"title":"ArticlesYouMayLikeBar_title__20BxA"};